import routerView from '@/views/layout/routerView'

export const junbrosRoute = [
  {
    path: 'junbros',
    name: '高阶拓客',
    icon: 'icon-xiansuo2',
    icon_img: 'nav03',
    component: routerView,
    hidden: false,
    children: [
      {
        path: 'advancedSearch',
        name: '高级搜索',
        icon: 'icon-xiansuo2',
        hidden: false,
        hide: false,
        component: () => import('@/views/clue/page/advancedSearch'),
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '高级搜索']
        }
      },
      {
        path: 'map',
        name: '商机地图',
        icon: 'icon-ditu',
        hidden: false,
        component: () => import('@/views/commercialMap/page/indexNew'),
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '商机地图']
        }
      },
      {
        path: 'parkCustomer',
        name: '园区获客',
        icon: 'icon-ditu',
        hidden: false,
        component: () => import('@/views/parkCustomer/page/indexNew'),
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '园区获客']
        }
      },
      {
        path: 'parkInfo',
        component: () => import('@/views/parkCustomer/page/parkInfo'),
        name: '园区信息',
        icon: 'icon-ditu',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '园区信息',
          icon: 'leftIcon2',
          breadcrumb: ['高阶拓客', '园区获客', '园区信息'],
          path: '/zxk/junbros/parkCustomer'
        }
      },
      {
        path: 'intelRecommend',
        name: '智能推荐',
        icon: 'icon-xiansuo2',
        hidden: false,
        component: () => import('@/views/clue/page/intelRecommend'),
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '智能推荐']
        }
      },
      {
        path: 'getCustomers',
        name: '匿名访客',
        icon: 'icon-xiansuo2',
        hidden: false,
        component: () => import('@/views/clue/page/getCustomers'),
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '匿名访客']
        }
      },
      {
        path: 'addSite',
        component: () => import('@/views/clue/page/addSite'),
        name: '添加站点',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '添加站点',
          icon: 'leftIcon2',
          breadcrumb: ['高阶拓客', '添加站点']
        }
      },
      {
        path: 'codeExplain',
        component: () => import('@/views/clue/page/codeExplain'),
        name: '代码安装说明',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '代码安装说明',
          icon: 'leftIcon2',
          // breadcrumb: ['高阶拓客', '代码安装说明']
        }
      },
      {
        path: 'codeTest',
        component: () => import('@/views/clue/page/codeTest'),
        name: '代码检测',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '代码检测',
          icon: 'leftIcon2',
          // breadcrumb: ['高阶拓客', '代码检测']
        }
      },

      // {
      //   path: 'index4',
      //   name: '商机订阅',
      //   icon: 'icon-xiansuo2',
      //   hidden: false,
      //   component: () => import('@/views/clue/page/index'),
      //   meta: {
      //     nextStart: true,
      //     breadcrumb: ['智能拓客', '商机订阅']
      //   }
      // }
      {
        path: 'subscribeList',
        component: () => import('@/views/clue/page/subscribeList'),
        name: '商机订阅',
        icon: 'icon-xiansuo2',
        hidden: false,
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '商机订阅']
        }
      },
      {
        path: 'subscribeManagement',
        component: () => import('@/views/clue/page/subscribeManagement'),
        name: '商机订阅管理',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '商机订阅管理',
          icon: 'leftIcon2',
          breadcrumb: ['高阶拓客', '商机订阅', '商机订阅管理'],
          path: '/zxk/junbros/subscribeList'
        }
      },
      {
        path: 'numberCleaningList',
        component: () => import('@/views/clue/page/numberCleaningList'),
        name: '号码清洗',
        icon: 'icon-xiansuo2',
        hidden: false,
        meta: {
          nextStart: true,
          breadcrumb: ['高阶拓客', '号码清洗']
        }
      },
    ]
  }
]
export default junbrosRoute
